import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Etiquetas Comidas

export async function getEtiquetasComidas(deleted) {
  return requests
    .get(constants.API_URL_REPORTES, `${urls.ETIQUETA_COMIDA}?&deleted=${deleted}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertEtiquetasComidas(payload) {
  return requests
    .postForm(constants.API_URL_REPORTES, urls.ETIQUETA_COMIDA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEtiquetasComidas(payload) {
  return requests
    .putForm(constants.API_URL_REPORTES, urls.ETIQUETA_COMIDA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEtiquetasComidas(id) {
  return requests
    .remove(constants.API_URL_REPORTES, `${urls.ETIQUETA_COMIDA}/${id}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getEtiquetasComidasById(id) {
  return requests
    .get(constants.API_URL_REPORTES, `${urls.ETIQUETA_COMIDA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getImprimirVentaById(payload) {
  return requests
    .get(
      constants.API_URL_REPORTES,
      `${urls.GET_REPORTE_IMPRIMIR_PMT}/${payload?.ventaId}?ocultarEtiquetaEnvio=${payload?.ocultarEtiquetaEnvio}&rotar180grados=${payload?.rotar180grados}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function requestImprimirVentaMasivo(ventasIds) {
  return requests
    .post(constants.API_URL_REPORTES, urls.GET_REPORTE_IMPRIMIR_PMT_MASIVO, ventasIds)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getLotesImpresion() {
  return requests.get(constants.API_URL_REPORTES, urls.GET_LOTES_IMPRESION).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getLotesImpresionFiltered(filter) {
  let url = urls.GET_LOTES_IMPRESION_FILTERED
  if (filter?.index !== null && filter?.index !== undefined) url += `?index=${filter?.index}`
  if (filter?.count) url += `&count=${filter?.count}`
  return requests.post(constants.API_URL_REPORTES, url, filter).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getImprimirVentaAbonoById(id) {
  return requests
    .get(constants.API_URL_REPORTES, `${urls.GET_REPORTE_FACTURA_ABONO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function getImprimirVentaFacturaById(id) {
  return requests
    .get(constants.API_URL_REPORTES, `${urls.GET_REPORTE_FACTURA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function getImprimirVentaFacturaProformaById(id) {
  return requests
    .get(constants.API_URL_REPORTES, `${urls.GET_REPORTE_FACTURA_PROFORMA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}
